import store from './store'

let choose = {};


function num_subj_verb(n, subj, verb) {
    if (n == 0) return no(subj) +  ' ' + verb + 's';
    else if (n == 1) return "one " + subj +  ' ' + verb + 's';
    else return n + ' ' + plural(subj) + ' ' + verb;
}

let no_dict = {
    person: "nobody",
};

let plural_dict = {
    person: "people"
}

function no(noun) {
    return no_dict[noun] || 'no ' + noun;
}

function plural(noun) {
    return plural_dict[noun] || noun + 's';
}

function replace_dollar_variables(s, vars) {
    return s.replace(/\$\w+/g, f => vars[f.slice(1)] );
}

function $t(s, params) {
    let f, lang = store.state.language;

    /*
    if ( labels[lang] ) f = labels[lang][s] || labels['en'][s] || s;
    else f = labels['en'][s] || s;
    */

    if ( choose[lang] ) f = choose[lang].labels[s] || s;
    else f = s;

    if (!params) return f;

    for (let key in params) {
        params[key] = $t(params[key]);
    }

    return typeof f == 'function' ? f(params) : replace_dollar_variables(f, params);
}


export default {
    choose,
    $t
}